import React, { useEffect, useState } from "react";
import BackButton from "./parts/BackButton";
import { useSelector } from "react-redux";
import { ethers } from "ethers";
import { removeLiquidity } from "../apis/blockchain";
import CrossCloseButton from "./parts/CrossCloseButton";

export default function () {
  const balanceFirst = useSelector((state) => state.modal.data.balanceFirst);
  const balanceSecond = useSelector((state) => state.modal.data.balanceSecond);
  const poolData = useSelector((state) => state.modal.data.poolData);
  const lpBalance = useSelector((state) => state.modal.data.lpBalance);
  const web3Context = useSelector((state) => state.modal.data.web3Context);
  const deadline = useSelector((state) => state.modal.data.deadline);
  const slippage = useSelector((state) => state.modal.data.slippage);
  const [value, setValue] = useState(100);

  const [recieveFirst, setRecieveFirst] = useState("");
  const [recieveSecond, setRecieveSecond] = useState("");

  const changeHandler = (e) => {
    let value = e.target.value;
    value = value.replace(/[^0-9]/g, "");
    value = value <= 100 ? value : 100;
    e.target.value = value;
    setValue(value);
  };

  useEffect(() => {
    setRecieveFirst(parseInt(balanceFirst * value * 1000000) / 100000000);
    setRecieveSecond(parseInt(balanceSecond * value * 1000000) / 100000000);
  }, [value]);

  const submit = (e) => {
    e.preventDefault();

    removeLiquidity(
      web3Context.web3.rAskoSwapRouterContract,
      poolData.first.address,
      poolData.second.address,
      (lpBalance * value) / 100,
      0,
      0,
      web3Context.currentAccountAddress,
      deadline * 60 + parseInt(Date.now() / 1000)
    );
  };

  return (
    <div className="modal modal_w593">
      <CrossCloseButton className="custom-cross-btn_black close_btn" />
      <header className="removeliq__header">
        <div className="removeliq__back">
          <BackButton className="removeliq__back-btn" />
          <h3 className="removeliq__back-text">
            Remove {poolData.first.name + "/" + poolData.second.name}
          </h3>
        </div>
      </header>
      <form className="removeliq__body" onSubmit={(e) => e.preventDefault()}>
        <div className="removeliq__label">
          Enter the % you'd like to remove:
        </div>
        <div className="removeliq__w250">
          <div className="removeliq__line">
            <input
              type="text"
              name="percent"
              className="removeliq__input"
              value={value}
              onChange={changeHandler}
            />
            <span className="removeliq__percent">%</span>
          </div>
          <div className="removeliq__display">
            <span>You will receive</span>
            <span>{recieveFirst + " " + poolData.first.name}</span>
            <span>{recieveSecond + " " + poolData.second.name}</span>
          </div>
        </div>
        <div className="removeliq__controls" onClick={submit}>
          {/* <button className="button-b">Enable</button> */}
          <button className="button-b">Remove</button>
        </div>
      </form>
    </div>
  );
}
